import { ReactNode, useState } from 'react';
import { Trans } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconChevron from '@/icons/Chevron.svg';

export const WithContext = ({
  context,
  children,
}: {
  context: string | null;
  children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Stack>
      {children}
      {context && (
        <Stack alignItems="flex-start" gap="4px">
          <Button variant="link-subtle" size="small" onPress={() => setIsOpen((prev) => !prev)}>
            {isOpen ? (
              <>
                <Trans id="article-actions.defect-context.hide-context">Hide context</Trans>
                <IconChevron up />
              </>
            ) : (
              <>
                <Trans id="article-actions.defect-context.view-context">View context</Trans>
                <IconChevron down />
              </>
            )}
          </Button>
          {isOpen && (
            <Paragraph size="200" whiteSpace="pre-wrap">
              &ldquo;{context}&rdquo;
            </Paragraph>
          )}
        </Stack>
      )}
    </Stack>
  );
};
